import uniq from 'lodash.uniq';
import {ColumnTypes} from 'src/modules/change-requests/constants';
import {EventFilterKeys} from 'src/modules/change-requests/typedefs';
import {ChangeRequest} from 'src/openapi/models/ChangeRequest';

export const extractColumnHeaderData = (filteredRows: ChangeRequest[], columnType: ColumnTypes): string[] => {
    return columnType === ColumnTypes.AUTHOR || columnType === ColumnTypes.STATUS
        ? uniq(filteredRows.map(row => row[columnType]))
        : uniq(filteredRows.map(row => row.event[columnType as EventFilterKeys]));
};
